import React, { JSX } from "react";
import { Button as AntButton } from "antd";
import type { ButtonProps as AntButtonProps } from "antd";

export interface ButtonProps extends AntButtonProps {
  /**  
   *  - **primary** — яркая заливка (antd `type="primary"`)  
   *  - **secondary** — нейтральная (antd `type="default"`)  
   *  - **outline** — прозрачная с границей (antd `ghost`)  
   */
  visualStyle?: "primary" | "secondary" | "outline";
}

/** Унифицированная кнопка (по мотивам shadcn/ui) */
export function Button({
  visualStyle = "primary",
  ...rest
}: ButtonProps): JSX.Element {
  let type: AntButtonProps["type"] = "primary";
  let ghost = false;

  if (visualStyle === "secondary") type = "default";
  if (visualStyle === "outline") {
    type = "default";
    ghost = true;
  }

  return <AntButton type={type} ghost={ghost} {...rest} />;
}
